import React, {useEffect, useState} from "react";
import {connect, useSelector} from "react-redux";

export function OngoingCount(props) {

const [value, setValue] = useState(props.value);
const digits = props.digits;

useEffect(() => {
    // pad with extra zeros if necessary
    if (value !== null) {
        let result = props.value.toString();
        let zerosNeeded = digits - result.length;
        while(zerosNeeded > 0) {
            result = '0' + result;
            zerosNeeded --;
        }
        setValue(result);
    }
}, [props.value])

    return (
        <div>
            <div style={{minWidth: "60px"}} className="iblock light-black count-number gap-right-s">{value}</div>
            {props.children}
            <div className="iblock content1 heavy-grey">{props.title}</div>
        </div>
    )
}

const mapStateToProps = () => ({})

export default connect(mapStateToProps)(OngoingCount);
